import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {ContactModel} from '@app/models/contact.model';
import {GtAttendantService} from '@app/services/gt-attendant.service';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {GtWhitepagesService} from '@app/services/gt-whitepages.service';
import {Click2callComponent} from '@app/shared/click2call/click2call.component';
import {BuilderFactory} from '@app/shared/utils/builder.factory';
import {GtPhoneNumberUtil} from '@app/shared/utils/gt-phone-number.util';
import {Contact} from '@gt-api';
import {TranslateService} from '@ngx-translate/core';
import {YellowPagesDatasource} from './yellow-pages.datasource';

@Component({
  selector: 'gt-yellow-pages-search',
  templateUrl: './yellow-pages-search.component.html',
  styleUrls: ['./yellow-pages-search.component.css']
})
export class YellowPagesSearchComponent implements OnInit {
  dataSource: YellowPagesDatasource | null;
  displayedColumns = ['name', 'number', 'actions'];

  selectedEntry: ContactModel | null;

  query: string;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  loading = false;

  constructor(
    private whitepagesService: GtWhitepagesService,
    private notificationService: GtNotificationService,
    private dialogRef: MatDialogRef<YellowPagesSearchComponent>,
    private authenticationService: GtAuthenticationService,
    private router: Router,
    private dialog: MatDialog,
    private attendantService: GtAttendantService,
    private translateService: TranslateService,
    private gtDirectoryService: GtDirectoryService
  ) {}

  ngOnInit() {
    this.dataSource = new YellowPagesDatasource(this.sort);
  }

  onClick() {
    this.loading = true;
    if (!this.query) {
      this.loading = false;
      return;
    }

    this.whitepagesService.search(this.query).subscribe(
      res => {
        this.dataSource.contactList = res.map(r => ContactModel.convertVCardModel(r));
      },
      e => {
        this.loading = false;
        this.notificationService.errorNotification.next(e);
      },
      () => {
        this.loading = false;
      }
    );
  }

  onClose() {
    this.dialogRef.close();
  }

  click2call(entry: ContactModel) {
    const dialogRef = this.dialog.open(Click2callComponent, {minWidth: 500});
    if (entry) {
      dialogRef.componentInstance.canEdit = false;
      dialogRef.componentInstance.name = entry.name;
      dialogRef.componentInstance.initialPhoneNumber = entry.phoneNumber;
    }
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.attendantService.click2Call(result.phoneNumber, result.displayNumber).subscribe(response => {
          if (response.code === 200) {
            this.notificationService.normalNotification.next(
              this.translateService.instant('contacts.calling', {
                number: GtPhoneNumberUtil.toDisplay(result.phoneNumber),
                disp_number: GtPhoneNumberUtil.toDisplay(result.displayNumber)
              })
            );
          } else {
            this.notificationService.errorNotification.next(this.translateService.instant('Request failed'));
          }
        });
      }
    });
    this.selectedEntry = null;
    this.dialogRef.close();
  }

  navigateToMsg(entry: ContactModel) {
    this.router.navigate(['/sms'], { queryParams: { receivers: entry.phoneNumber } });
    this.selectedEntry = null;
    this.dialogRef.close();
  }

  handleRowClick(entry: ContactModel) {
    // let contact;
    let existingContact;
    this.gtDirectoryService.getContacts(this.authenticationService.oname, true).subscribe(contacts => {
      existingContact = contacts.find(x => x.phoneNumber === entry.phoneNumber);
    });

    if (existingContact) {
      this.selectedEntry = existingContact;
    } else {
      const newContact = BuilderFactory.createBuilder<Contact>()
        .id(-1) // We want id = -1 because contact does not exist alread
        .fullNumber(entry.phoneNumber)
        .firstName(entry.name)
        .build();
      newContact['@type'] = 'Contact';
      this.selectedEntry = ContactModel.convertContactModel(newContact);
    }
  }

  backToTable() {
    this.selectedEntry = null;
  }
}
